import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurNoblePursuit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-noble-pursuit" ref={ref} className={cn("bg-background py-24 relative overflow-hidden transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5")}>
      <div className="container mx-auto px-6 md:px-12 max-w-[90rem]">
        <div className="flex flex-col lg:flex-row items-center relative">
          <div className="w-full lg:w-[60%] relative z-0">
            <div className="relative aspect-[3/4] md:aspect-[4/3] lg:aspect-[3/4] w-full overflow-hidden rounded-md shadow-md">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569214/img/antique_restoration_process_museum.png" alt="Antique restorer meticulously working on a vintage artifact" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              <div className="absolute inset-0 bg-black/10 pointer-events-none" />
            </div>
          </div>

          <div className="w-full lg:w-[50%] z-10 mt-8 lg:mt-0 lg:-ml-24">
            <div className="bg-background/95 backdrop-blur-sm p-8 md:p-12 rounded-md shadow-xl border border-border">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-10">
                Our Noble Pursuit
                <span className="block mt-4 h-1 w-24 bg-secondary rounded-full" />
              </h2>
              <div className="space-y-6 text-muted-foreground font-sans leading-relaxed text-lg">
                <p>
                  At Nobilities Antiques, we are more than just traders; we are
                  guardians of history. In an age of mass production, we stand
                  firm in our commitment to 100% authenticity.
                </p>
                <p>
                  Every artifact in our collection undergoes a rigorous
                  examination by our expert curators, ensuring that the legacy
                  you acquire is genuine. We preserve the stories etched into
                  wood, metal, and stone, bridging the gap between the 18th
                  century and the modern world.
                </p>
              </div>
              <div className="mt-8">
                <Button asChild variant="secondary" className="font-bold text-base px-8 py-6 rounded-md shadow-none transition-all hover:bg-secondary/90">
                  <Link to="#">Read Our Story</Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}